export default function InCourseExperienceHeaderWrapper({ children, ...rest }) {
  return (
    <div
      css={({ palette, spacing }) => ({
        height: 65,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        padding: spacing(0, 1),
        backgroundColor: palette.background.paper,
        borderBottom: `1px solid ${palette.divider}`,
      })}
      {...rest}
    >
      {children}
    </div>
  );
}
